import { render, staticRenderFns } from "./PaginationList.vue?vue&type=template&id=0515756a&scoped=true&"
import script from "./PaginationList.vue?vue&type=script&lang=js&"
export * from "./PaginationList.vue?vue&type=script&lang=js&"
import style0 from "./PaginationList.vue?vue&type=style&index=0&id=0515756a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0515756a",
  null
  
)

export default component.exports